import React, {Component} from 'react';
import './App.css';
import 'rc-time-picker/assets/index.css';
import {Provider} from 'react-redux';
import {applyMiddleware, createStore} from 'redux';
import reducers from './reducers';
import {AUTHENTICATED, getUserTokens,signOutAction} from './actions/auth_actions';
import thunk from 'redux-thunk'
import BrowserAppRoutes from "./views/router";

const store = createStore(reducers, applyMiddleware(thunk));

let authHeaders = JSON.parse(localStorage.getItem('authentication_headers'));
let currentUser = JSON.parse(localStorage.getItem('user'));

if (authHeaders && currentUser) {
    store.dispatch(getUserTokens());
    store.dispatch({type: AUTHENTICATED, userRole: currentUser.role,userName:currentUser.name});
}
else {
    store.dispatch(signOutAction());
}

class App extends Component {
    render() {
        return (
            <Provider store={store}>
                <BrowserAppRoutes/>
            </Provider>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js